// extracted by css-extract-rspack-plugin
export default {"root":"root-DB3jYO"};